import { Button, styled } from '@mui/material'
import { FlexBetween, FlexColumn } from 'styles'

export const OrderModalWrap = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(5, 7, 20, 0.6);
  backdrop-filter: blur(4px);
  z-index: 300;
`
export const OrderMainWrap = styled('div')`
  width: 512px;
  background: ${(props) => props.theme.color.bg};
  border-radius: 8px 8px 0 0;
  padding: 16px;
  position: absolute;
  bottom: 0;
  left: 0;

  ${(props) => props.theme.breakpoints.down('md')} {
    width: 100%;
  }
`
export const OrderModalRow = styled(FlexColumn)`
  width: 100%;
  padding: 8px 0;
  border-bottom: 1px solid ${(props) => props.theme.color.text10};
  .buy {
    color: ${(props) => props.theme.color.buy30};
  }
  .sell {
    color: ${(props) => props.theme.color.sell30};
  }
  .open {
    background: ${(props) => props.theme.color.notificationGreen01};
    color: ${(props) => props.theme.color.notificationGreen02};
  }
  .filled {
    color: ${(props) => props.theme.color.text50};
  }
  .cancelled {
    color: ${(props) => props.theme.color.notificationRed02};
  }
  .cancelling {
    background: ${(props) => props.theme.color.notificationRed01};
    color: ${(props) => props.theme.color.notificationRed02};
  }
  .confirming {
    background: ${(props) => props.theme.color.notificationBlue01};
    color: ${(props) => props.theme.color.notificationBlue02};
  }
  .partial-fill {
    background: ${(props) => props.theme.color?.notificationPurple01};
    color: ${(props) => props.theme.color?.notificationPurple02};
  }
`
export const OrderModalRowLabel = styled(FlexBetween)`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: ${(props) => props.theme.color.text50};
`
export const OrderModalRowInfo = styled(FlexBetween)`
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: ${(props) => props.theme.color.text90};
`
export const CancelButton = styled(Button)`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.theme.color.text00}!important;

  border-radius: 6px;
  background: ${(props) => props.theme.color.sell30}!important;
  border: 1px solid ${(props) => props.theme.color.sell40}!important;
  margin-top: 22px !important;
`
